import PostAuthor, { PostAuthorProps } from './PostAuthor'
import PostActions, { PostActionsProps } from './OpeningPostActions'
import PostMetadata, { PostMetadataProps } from './PostMetadata'
import OpeningPostContent, { OpeningPostContentProps } from './OpeningPostContent'
import OpeningPostContentActions, { OpeningPostContentActionsProps } from './OpeningPostContentActions'
import UserProfileActions from './UserProfileActions'
import PostAuthorSignature from './PostAuthorSignature'
import Poll from './Poll'
import classnames from 'classnames'
import TopicPills, { TopicPillsProps } from '../TopicPills'

export interface OpeningPostProps
  extends PostAuthorProps,
    PostMetadataProps,
    OpeningPostContentProps,
    PostActionsProps,
    OpeningPostContentActionsProps,
    TopicPillsProps {}

const OpeningPost = ({
  topicId,
  contentType,
  author,
  title,
  content,
  publishedAt,
  pending,
  spam,
  trashed,
  destinationUrl,
  pinnedReply,
  bestAnswer,
  userId,
  votedBy,
  votes,
  likedBy,
  likes,
  showEditor,
  isProductboardNoteCreationEnabled,
  isSalesforceCaseEscalationEnabled,
  isZendeskTicketEscalationEnabled,
  isFreshdeskTicketEscalationEnabled,
  isIntercomCreateConversationEnabled,
  onShowEditor,
  onCancel,
  onChangeVote,
  onChangeLike,
  onShowAlert,
  onApprove,
  onChangeContent,
  publicId,
  visibleReplyCount,
  poll,
  onPollUpdate,
  reported,
  reportedContent,
  onResolve
}: OpeningPostProps) => {
  const hasPoll = poll && onPollUpdate && poll.options
  return (
    <div className='topic-moderation--posts-first'>
      <article
        data-post-id={topicId}
        className={classnames('post', 'panel', 'panel-default', 'status--author', {
          'status--spam': spam,
          'status--reported': reported
        })}
      >
        <div className='post--inner-wrapper'>
          <div className='panel-body'>
            <PostAuthor author={author} />
            <div className='post--content-container'>
              <PostMetadata publishedAt={publishedAt}>
                <TopicPills isAuthor spam={spam} pending={pending} trashed={trashed} reported={reported} />
              </PostMetadata>

              <OpeningPostContent
                topicId={topicId}
                contentType={contentType}
                content={content}
                pinnedReply={pinnedReply}
                bestAnswer={bestAnswer}
                showEditor={showEditor}
                onChangeContent={onChangeContent}
                onCancel={onCancel}
                onShowAlert={onShowAlert}
                reportedContent={reportedContent}
              />

              {hasPoll && (
                <Poll
                  contentType={contentType}
                  onShowAlert={onShowAlert}
                  topicId={topicId}
                  poll={poll}
                  onPollUpdate={onPollUpdate}
                />
              )}

              {author.signature && <PostAuthorSignature signature={author.signature} />}
              {!spam && (
                <OpeningPostContentActions
                  author={author}
                  content={content}
                  topicId={topicId}
                  publicId={publicId}
                  contentType={contentType}
                  trashed={trashed}
                  votedBy={votedBy}
                  likedBy={likedBy}
                  votes={votes}
                  likes={likes}
                  userId={userId}
                  isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
                  isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
                  isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
                  isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
                  isIntercomCreateConversationEnabled={isIntercomCreateConversationEnabled}
                  onChangeVote={onChangeVote}
                  onChangeLike={onChangeLike}
                  onShowAlert={onShowAlert}
                />
              )}
            </div>
          </div>
          {!spam && (
            <div className='post__panel-footer clearfix'>
              <UserProfileActions authorId={author.id} loggedInUserId={userId} />
              <PostActions
                topicId={topicId}
                contentType={contentType}
                author={author}
                title={title}
                content={content}
                pending={pending}
                trashed={trashed}
                reported={reported}
                userId={userId}
                destinationUrl={destinationUrl}
                isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
                isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
                isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
                isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
                isIntercomCreateConversationEnabled={isIntercomCreateConversationEnabled}
                onApprove={onApprove}
                onResolve={onResolve}
                onShowAlert={onShowAlert}
                onShowEditor={onShowEditor}
                publicId={publicId}
                visibleReplyCount={visibleReplyCount}
                reportedContent={reportedContent}
              />
            </div>
          )}
        </div>
      </article>
    </div>
  )
}

export default OpeningPost
